module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2n6r9r-0393e4c510f1ac98f4f1ad662f6f87fc.svg";